import { Alert, Avatar, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  const [auth, setAuth] = useState({
    name: "",
    password: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Uncomment below if you want to redirect authenticated users
    // if (localStorage.getItem("user") !== null) {
    //   navigate("/");
    // }
  }, []);

  const handleChange = (event) => {
    const { value, name } = event.target;
    setAuth({ ...auth, [name]: value });
  };

  const handleLogin = () => {
    if (!auth.name.trim() || !auth.password.trim()) {
      setAlertSeverity("error");
      setAlertMessage("Please enter both name and password.");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    axios.post("http://localhost:8081/auth/signin", auth)
      .then((response) => {
        const { status, message } = response.data;

        if (status === "OK") {
          setAlertSeverity("success");
          setAlertMessage("Login successful");
          setShowAlert(true);

          setTimeout(() => {
            setShowAlert(false);
            // localStorage.setItem("token", response.data.token);
            // localStorage.setItem("user", JSON.stringify(response.data.user));
            navigate("/");
          }, 1500);
        } else {
          setAlertSeverity("error");
          setAlertMessage(message || "Login failed");
          setShowAlert(true);
          setTimeout(() => setShowAlert(false), 3000);
        }
      })
      .catch((error) => {
        const errMsg = error.response?.data?.message || "Login failed";
        setAlertSeverity("error");
        setAlertMessage(errMsg);
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
      });
  };

  return (
    <Box sx={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Paper elevation={3} sx={{
        width: "25%",
        height: "65vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 3,
        padding: 2,
        borderColor: "#7b1fa2",
        borderWidth: 2,
        borderStyle: "solid",
        position: "relative"
      }}>
        <Avatar sx={{ bgcolor: "#7b1fa2" }} src="/broken-image.jpg" />
        <Typography variant="h5" gutterBottom>LOGIN</Typography>

        {showAlert && (
          <Alert severity={alertSeverity} sx={{
            position: "absolute",
            top: 10,
            width: "80%",
            left: "10%",
            zIndex: 1
          }}>
            {alertMessage}
          </Alert>
        )}

        <TextField
          label="Name"
          variant="outlined"
          name="name"
          value={auth.name}
          onChange={handleChange}
          fullWidth
          sx={{
            "& label.Mui-focused": { color: "#7b1fa2" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "grey" },
              "&:hover fieldset": { borderColor: "#7b1fa2" },
              "&.Mui-focused fieldset": { borderColor: "#7b1fa2" },
            },
          }}
        />

        <TextField
          label="Password"
          variant="outlined"
          name="password"
          type="password"
          value={auth.password}
          onChange={handleChange}
          fullWidth
          sx={{
            "& label.Mui-focused": { color: "#7b1fa2" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "grey" },
              "&:hover fieldset": { borderColor: "#7b1fa2" },
              "&.Mui-focused fieldset": { borderColor: "#7b1fa2" },
            },
          }}
        />

        <Box sx={{ width: "100%", textAlign: "right" }}>
          <Link to="/forgetpassword">Forget password</Link>
        </Box>

        <Button
          variant="contained"
          onClick={handleLogin}
          sx={{ backgroundColor: "#7b1fa2", "&:hover": { backgroundColor: "#6a1b9a" } }}
        >
          LOGIN
        </Button>

        <Typography variant="body2">
          Don't have an account?&emsp;
          <Link to="/signup">Signup</Link>
        </Typography>
      </Paper>
    </Box>
  );
};

export default Login;
